import React from "react";
import "./Card.css";
const Card = (props) => {
  return (
    <div className="wrapper">
      <div className="card">
        <div className="image">
          <img src={props.image} alt="Lago di Braies" />
        </div>
        <div className="details">
          <span className="tag">{props.Tag}</span>
          <h2 className="title">{props.Title}</h2>
          <p>{props.Content.substr(0, 100)};</p>
        </div>
      </div>
    </div>
  );
};

export default Card;
